import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import i18n from 'i18next';

import { Checkbox } from 'uikit/inputs';
import { Typo } from 'uikit/content';

import styles from '../styles/asyncFilterOption.module.css';

const AsyncFilterOption = ({
  code = '',
  id = null,
  isSelected = false,
  isSingleSelect = false,
  name,
  onChange = () => {},
  value,
}) => {
  const inputId = `filter-option-${value}`;

  const label = (
    <label className={styles.label} htmlFor={inputId}>
      <Typo element="span" noWrap variant="s02">
        {name}
      </Typo>
      <Typo className={styles.body} color="secondary" element="span" noWrap variant="s01">
        {code && (
          <Typo element="span" noWrap variant="s01">
            {i18n.t('code-prefix-label', { code })}
          </Typo>
        )}
        {i18n.t('id-prefix-label', { id })}
      </Typo>
    </label>
  );

  return (
    <div className={classnames(styles.element, isSingleSelect && styles.isSingleSelect)}>
      {isSingleSelect && label}
      <Checkbox
        className={styles.checkbox}
        checkedIcon={isSingleSelect ? <CheckOutlinedIcon /> : <CheckBoxIcon />}
        id={inputId}
        isChecked={isSelected}
        onChange={onChange}
      />
      {!isSingleSelect && label}
    </div>
  );
};

AsyncFilterOption.propTypes = {
  code: PropTypes.string,
  id: PropTypes.number,
  isSelected: PropTypes.bool,
  isSingleSelect: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
};

export default AsyncFilterOption;
